// そのツールを初めて選んだときだけ、1 行の要約をトーストで出す。
// 説明を常時表示しないための仕組みで、見たツールは localStorage に覚える。
import { watch } from 'vue'
import { useUiStore, type ToolId } from '@/stores/uiStore'
import { guideFor, tx } from '@/help/toolGuides'
import { toast } from './useToast'
import { t } from '@/i18n'
import type { I18nKey } from '@/i18n'

const KEY = 'bpe.toolhints.v1'

function load(): Set<string> {
  try {
    const raw = localStorage.getItem(KEY)
    const v = raw ? (JSON.parse(raw) as unknown) : null
    return new Set(Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [])
  } catch {
    return new Set()
  }
}
function save(seen: Set<string>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([...seen]))
  } catch {
    /* ignore */
  }
}

export function resetToolHints(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
  seen = load()
}

let seen = load()

/** 初回だけヒントを出す。すでに見たツールなら false */
export function showToolHint(tool: ToolId): boolean {
  if (seen.has(tool)) return false
  seen.add(tool)
  save(seen)
  const name = t(`tool.${tool}` as I18nKey)
  toast.info(`${name}: ${tx(guideFor(tool).summary)} ${t('guide.hintSuffix')}`, 5000)
  return true
}

export function useToolHints(): void {
  const ui = useUiStore()
  watch(
    () => ui.activeTool,
    tool => showToolHint(tool)
  )
}
